import { render, staticRenderFns } from "./DelegatedRequest.vue?vue&type=template&id=5fb812b4&scoped=true"
import script from "./DelegatedRequest.vue?vue&type=script&lang=js"
export * from "./DelegatedRequest.vue?vue&type=script&lang=js"
import style0 from "./DelegatedRequest.vue?vue&type=style&index=0&id=5fb812b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb812b4",
  null
  
)

export default component.exports